<template>
  <div class="container">
    <div class="title">
      <img src="../../src/assets/images/pupil/logo.png" alt="" />
    </div>
    <div class="headerBac"></div>

    <div class="contentBox dzyjbox">
        <div class="dzyjItem" v-for="(item, index) in dzyjList" :key="index">
          <div class="title" @click="toDetail(item)">{{ item.pName }}：{{ item.fName }}</div>
          <div class="time">{{ item.showTime }}</div>
          <div class="desc" :title="item.digest">{{ item.digest }}</div>

        </div>
      <div class="pageDiv">
        <div class="first" @click="toFirst">首页</div>
        <el-pagination background :page-size="pageSize" layout="prev, pager, next" :total="total"
          @current-change="handleCurrentChange" :current-page.sync="currentPage" prev-text="上一页" next-text="下一页">
        </el-pagination>
        <div class="first" @click="toEnd">尾页</div>
      </div>

    </div>
    <div class="footBac"></div>

  </div>
</template>
<script>
import API from "../../apis/index";

export default {
  name: "Pupil",
  data() {
    return {
      dzyjList: [],
      currentPage: 1,
      pageSize: 10,
      pageNum: 1,
      total: 0,
      pages: 0,
    };
  },
  mounted() {
    const currentRouter = {
      name: "弟子业绩",
      path: "/pupil",
    };

    localStorage.setItem("currentRouter", JSON.stringify(currentRouter));
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.$http
        .get(`${API.getForum}?type=3&pageNum=${this.pageNum}&pageSize=10`)
        .then((res) => {
          console.log(res.data.data);
          this.dzyjList = res.data.data.list;
          this.total = res.data.data.total;
          this.pages = res.data.data.pages;
        });
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageNum = val;
      this.init();
    },
    toDetail(item) {
      const params = {
        fId: item.fId
      }
      console.log(item)
      this.$router.push({
        path: '/pupilDetail',
        query: {
          item: JSON.stringify(params)
        },
      });
    },
    toFirst() {
      this.pageNum = 1;
      this.currentPage = 1;
      this.init();
    },
    toEnd() {
      this.pageNum = this.pages;
      this.currentPage = this.pages;
      this.init();
    },
  },
};
</script>
<style scoped>
.container {
  width: 1000px;
  padding: 0 0 90px;
}

.headerBac{
    width: 100%;
    height: 60px;
    background: url("../../src/assets/images/headerBac.png") no-repeat;
    background-size: 100% 100%;
    margin-top: 20px;

}
.footBac{
    width: 100%;
    height: 60px;
    background: url("../../src/assets/images/footBac.png") no-repeat;
    background-size: 100% 100%;

}
.contentBox {
    width: 100%;
    /* height: 1098px; */
    background: url("../../src/assets/images/bodyBac.png") no-repeat;
    background-size: 100% 100%;
}

.dzyjbox {
  display: flex;
  flex-direction: column;
  /* justify-content: space-between;
  align-items: center; */
  padding: 13px 45px 53px;
}

.dzyjItem {
  height: 150px;
  border-bottom: 1px solid #eae0d5;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.title {
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #391603;
  line-height: 22px;
  margin-bottom: 10px;
  cursor: pointer;
}

.time {
  font-size: 12px;
  font-family: PingFangTC-Regular, PingFangTC;
  font-weight: 400;
  color: #391603;
  line-height: 17px;
}
.desc {
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #553827;
  line-height: 24px;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.pageDiv {
  margin-top: 30px;
  display: flex;
  justify-content: center;
}

::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #af1f23;
}

::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active:hover {
  color: #fff;
}

::v-deep .el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: #af1f23;
}

::v-deep .el-pagination.is-background {
  display: flex;
  padding: 0;
}

::v-deep .el-pagination.is-background .el-pager {
  display: flex;
}

::v-deep .el-pagination.is-background .el-pager li {
  margin: 0;
  width: 40px;
  height: 40px;
  border: 1px solid #eae0d5;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
}

::v-deep .el-pagination.is-background .btn-next,
::v-deep .el-pagination.is-background .btn-prev {
  width: 72px;
  height: 40px;
  border: 1px solid #eae0d5;
  margin: 0;
  background-color: transparent;
}

.first {
  width: 72px;
  height: 40px;
  border: 1px solid #eae0d5;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
</style>